import { Grid } from "@mui/material";
import Loading from "./Loading";
import classes from "./FormContainer.module.css";
import MultiLanTxt from "../MultiLanTxt/MultiLanTxt";

const FormContainer = ({
  children,
  addText,
  forceLtr,
  isLoading,
  observe,
  edit,
  fromDraft,
  multiLanTid,
  loadingXS,
  loadingSM,
  loadingMD,
  headerXS,
  headerSM,
  headerMD,
}) => {
  return (
    <Grid className={forceLtr ? classes.forceLtr : null} container sx={{ pt: { xs: 4, sm: 5, md: 7 } }}>
      <Grid
        item
        xs={headerXS || 11.4}
        sm={headerSM || 11}
        md={headerMD || 10.8}
        sx={{
          margin: "auto",
          pb: { xs: 4, sm: 2, md: 2 },
          display: { xs: "flex" },
          justifyContent: { xs: "center", md: "start" },
          fontSize: { xs: 14, md: 16 },
        }}
      >
        <h2>
          {multiLanTid ? (
            observe ? (
              <>
                <MultiLanTxt tid="VIEW_FORM_TITLE" /> <MultiLanTxt tid={multiLanTid} />{" "}
                <MultiLanTxt tid="INFORMATION_FORM_TITLE" />{" "}
              </>
            ) : edit ? (
              <>
                <MultiLanTxt tid="EDIT_FORM_TITLE" /> <MultiLanTxt tid={multiLanTid} />{" "}
                <MultiLanTxt tid="INFORMATION_FORM_TITLE" />{" "}
              </>
            ) : fromDraft ? (
              <>
                <MultiLanTxt tid={multiLanTid} /> <MultiLanTxt tid="DRAFT_FORM_TITLE" />{" "}
              </>
            ) : (
              <>
                <MultiLanTxt tid="ADD_FORM_TITLE" /> <MultiLanTxt tid={multiLanTid} />{" "}
                <MultiLanTxt tid="NEW_FORM_TITLE" />{" "}
              </>
            )
          ) : (
            addText
          )}
        </h2>
      </Grid>
      <Loading
        isLoading={isLoading}
        children={children}
        loadingXS={loadingXS}
        loadingSM={loadingSM}
        loadingMD={loadingMD}
      />
      {/* <Grid container item xs={11.2} sm={10.5} md={10} sx={{ margin: "auto", pt: { lg: 2, xl: 3 } }}>
        {isLoading ? <LoadingOverLoadedPage /> : children}
      </Grid> */}
    </Grid>
  );
};

export default FormContainer;
